import { useRef } from 'react'

import type { HeaderMenuApi } from './HeaderMenu'

const stub: HeaderMenuApi = {
  closeMenu: () => {
    console.warn('Не удалось закрыть меню')
  },
  openMenu: () => {
    console.warn('Не удалось открыть меню')
  },
  toggleMenu: () => {
    console.warn('Не удалось переключить меню')
  },
}

export const useHeaderApi = () => {
  return useRef(stub)
}
